// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__11tkI","requiredAsterisk":"Info_requiredAsterisk__Dmiqf"};